// La base del botón de la ficha («Personalizar ahora») y la del botón que
// vuelve a un diseño a medias («Continuar con tu diseño»), por idioma.
//
// Viven en un módulo LIGERO (sólo importa `localeDelCliente` de
// i18n-overrides) porque las usa el ENTRY `index.ts`, que no puede
// arrastrar los diccionarios. Son el defecto cuando el comercio no fija su
// propio texto —o cuando, en un mercado de otro idioma, su texto en es NO
// se aplica (`elCopyDelComercioAplica`)—. es byte a byte igual; un idioma
// sin tabla cae al es.

import { localeDelCliente } from './i18n-overrides.js';

const TRIGGER: Record<string, string> = {
  es: 'Personalizar ahora',
  en: 'Personalize now',
  pt: 'Personalizar agora',
};
const RESUME: Record<string, string> = {
  es: 'Continuar con tu diseño',
  en: 'Continue your design',
  pt: 'Continuar o teu design',
};

/** «Personalizar ahora» en el idioma del cliente. */
export function etiquetaTrigger(): string {
  return TRIGGER[localeDelCliente()] ?? TRIGGER.es!;
}

/** «Continuar con tu diseño» en el idioma del cliente. */
export function etiquetaResume(): string {
  return RESUME[localeDelCliente()] ?? RESUME.es!;
}
